import React, { useEffect, useState } from 'react'
import './App.css';
import Navbar from './pages/Navbar/Navbar';
import { Routes, Route } from "react-router-dom";
import Error from './pages/Error';
import HomePage from "./pages/Homepage";
import Signup from './pages/Authentication/Signup';
import Login from './pages/Authentication/Login';
import StartingPage from './pages/StartingPage';
import Sells from './pages/Sells';
import Contact from './pages/Contact';
import ABout from './pages/ABout';
import ForgetPass from './pages/resetPassword/ForgetPass';
import PasswordReset from './pages/resetPassword/PasswordReset';
import Order from './Ordercomponent/Order';
import Payment from './Ordercomponent/Payment';
import Preloader from './pages/Preloader';

function App() {

  const [loading, setLoadiing] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setLoadiing(true)
    }, 3000)
  })

  return (
    <>
      {
        loading ? <div>
          <Navbar />
          <Routes>

            <Route exact path='/' element={<StartingPage />} />
            <Route exact path='/sells/order/payment' element={<Payment />} />

            <Route exact path='/sells' element={<Sells />} />
            <Route exact path='/contact' element={<Contact />} />
            <Route exact path='/about' element={<ABout />} />
            <Route exact path='/home' element={<HomePage />} />
            <Route exact path='/sells/order' element={<Order />} />
            <Route exact path='/signup' element={<Signup />} />
            <Route exact path='/login' element={<Login />} />
            <Route exact path='*' element={<Error />} />
            <Route exact path='/forgetPass' element={<ForgetPass />} />
            <Route exact path='/forgetPass/:id/:token' element={<PasswordReset />} />

          </Routes>

        </div > : <Preloader />
      }
    </>

  )
}

export default App;
